import moment from 'moment'
import {api} from './api'

export class PendingApi {
    constructor(tag, endpoint, context) {
        this.tag = tag
        this.endpoint = endpoint
        this.context = context
    }
    
    post(path, data) {
        console.log(data)
        return new Promise((resolve, reject) => {
            let pending = this.get([])
            pending.push({
                path,
                data,
                date: moment().format('YYYY-MM-DD HH:MM:SS'),
            })
            this.save(pending, resolve)
        });
    }
    
    save(pending, resolve) {
        let localData = localStorage.getItem('pending')
        let data = {}
        if (localData) {
            data = JSON.parse(localData)
        }
        
        data[this.tag] = pending
        
        localStorage.setItem('pending', JSON.stringify(data))
        
        resolve(data)
    }
    
    clear() {
        let localData = localStorage.getItem('pending')
        let data = {}
        if (localData) {
            data = JSON.parse(localData)
        }
        
        data[this.tag] = []
        
        localStorage.setItem('pending', JSON.stringify(data))
    }
    
    get(defaultData) {
        let localData = localStorage.getItem('pending')
        let data = {}
        if(localData) {
            data = JSON.parse(localData)
        }
        
        if(data[this.tag]) {
            return data[this.tag]
        } else {
            return defaultData
        }
    }
    
    process() {
        let pending = this.get([])
        pending.forEach(job => {
            let data = job.data
            data.created_at = job.date
            api(this.endpoint).post(job.path, data)
            .then(() => {
                this.context.$noty.success('Saved pending request.')
            })
            .catch(() => {
                this.context.$noty.error('A pending request did not pass validation.')
            })
        })
        
        this.clear()
    }
}

export default {
    install(Vue, options) {
        Vue.prototype.$pendingApi = function(tag, endpoint) {
            return new PendingApi(tag, endpoint, this);
        };
    }
}